// AUTO-GENERATED from /app/backend/data/formulaire_v2.json
// Mappage officiel Région -> Bureaux (extrait du formulaire Zoho Deluge)

export const REGION_BUREAUX = {
  "Abitibi-Témiscamingue": [
    "Bureau Amos",
    "Bureau Chibougamau",
    "Bureau Kuujjuaq",
    "Bureau La Sarre",
    "Bureau Rouyn-Noranda",
    "Bureau Val-d'Or",
    "Bureau du Nord",
    "Bureau Mistissini",
    "Bureau Némaska",
    "Bureau Waswanipi",
    "Bureau Ivujivik - Baie d'Hudson",
    "Bureau Akulivik - Baie d'Hudson",
    "Bureau Puvirnituq - Baie d'Hudson",
    "Bureau Inukjuak - Baie d'Hudson",
    "Bureau Kuujjuarapik - Baie d'Hudson",
    "Bureau Umiujaq - Baie d'Hudson",
    "Bureau Chisasibi - Baie James",
    "Bureau Wemindji - Baie James",
    "Bureau Eastmain - Baie James",
    "Bureau Oujé-Bougoumou",
    "Bureau Salluit - Baie d'Hudson",
    "Bureau Whapmagoostui - Baie d'Hudson",
    "Bureau Kangiqsualujjuaq (George River) - Baie d'Ungava",
    "Bureau Kangiqsujuaq (Wakeham Bay) - Baie d'Ungava",
    "Bureau Kangirsuk - Baie D'Ungava",
    "Bureau Quaqtaq- Baie d'Ungava",
    "Bureau Aupaluk - Baie d'Ungava",
    "Bureau Tasiujaq - Baie D'Ungava",
    "Bureau Ville-Marie",
    "Bureau Semel",
    "Bureau Waskaganish - Baie James"
  ],
  "Côte-Nord": [
    "Bureau Sept-Iles",
    "Bureau Baie-Comeau",
    "Bureau Forestville",
    "Bureau Pessamit"
  ],
  "Estrie": [
    "Bureau Sherbrooke (civil)",
    "Bureau Coaticook",
    "Bureau Thetford Mines",
    "Bureau Val-des-Sources",
    "Bureau Lac-Mégantic",
    "Bureau Magog",
    "Bureau Sherbrooke (section criminelle)",
    "Bureau Sherbrooke (section jeunesse)",
    "Bureau Windsor",
    "Bureau Stanstead",
    "Bureau Disraeli"
  ],
  "Laurentides-Lanaudière": [
    "Bureau Saint-Jérôme",
    "Bureau Joliette",
    "Bureau Mont-Laurier",
    "Bureau Sainte-Thérèse",
    "Bureau Repentigny",
    "Bureau Sainte-Agathe",
    "Bureau Lachute",
    "Bureau Saint-Eustache",
    "Bureau Terrebonne"
  ],
  "Mauricie et du Centre-du-Québec": [
    "Bureau Trois-Rivières (civile et familiale)",
    "Bureau Shawinigan",
    "Bureau La Tuque",
    "Bureau Drummondville",
    "Bureau Victoriaville",
    "Bureau Louiseville",
    "Bureau Trois-Rivières (criminelle et jeunesse)"
  ],
  "Bas-Saint-Laurent Gaspésie": [
    "Bureau Cabano",
    "Bureau New Richmond",
    "Bureau Iles-de-la-Madeleine",
    "Bureau Gaspé",
    "Bureau Sainte-Anne-des-Monts",
    "Bureau Rivière-du-Loup",
    "Bureau Chandler",
    "Bureau Matane",
    "Bureau Amqui",
    "Bureau Rimouski",
    "Bureau Trois-Pistoles",
    "Bureau Saint-Pascal",
    "Bureau Paspébiac",
    "Bureau Matapédia",
    "Bureau La Pocatière"
  ],
  "Montréal Laval": [
    "Bureau Droit criminel et pénal",
    "Bureau Laval (Civil)",
    "Bureau Centre-Sud (Civil)",
    "Bureau Droit de la jeunesse",
    "Bureau Maisonneuve-Mercier",
    "Bureau Montréal-Nord",
    "Bureau Côte-des-Neiges",
    "Bureau Crémazie",
    "Bureau Sud-Ouest",
    "Bureau Droit de l'immigration",
    "Bureau Centre-Sud (Droit administratif)",
    "Bureau Laval (Carcéral)",
    "Bureau Laval (Criminel et jeunesse)",
    "Bureau garde téléphonique (Droit criminel et pénal - Service de garde)",
    "Bureau Droit de la santé",
    "Bureau Pointe Saint-Charles et Petite Bourgogne"
  ],
  "Outaouais": [
    "Bureau Gatineau (section civile, famille et jeunesse)",
    "Bureau Campbell's Bay",
    "Bureau Maniwaki",
    "Bureau Buckingham",
    "Bureau Gatineau (section criminelle)",
    "Bureau Gatineau (section famille)",
    "Bureau Gatineau (section civile)",
    "Bureau Gatineau (section jeunesse)",
    "Bureau Aylmer"
  ],
  "Québec": [
    "Bureau Charlesbourg",
    "Bureau La Malbaie",
    "Bureau Lévis",
    "Bureau Montmagny",
    "Bureau Saint-Joseph-de-Beauce",
    "Bureau Saint-Georges-de-Beauce",
    "Bureau Québec (section jeunesse)",
    "Bureau Québec (section criminelle)",
    "Bureau Centre-Ville",
    "Bureau Sainte-Marie-de-Beauce",
    "Bureau Saint-Raymond",
    "Bureau Immigration"
  ],
  "Rive-Sud": [
    "Bureau Longueuil-Droit civil",
    "Bureau Châteauguay",
    "Bureau Saint-Jean-sur-Richelieu",
    "Bureau Saint-Hyacinthe",
    "Bureau Sorel-Tracy",
    "Bureau Granby",
    "Bureau Salaberry-de-Valleyfield",
    "Bureau Cowansville",
    "Bureau Longueuil (section criminelle)",
    "Bureau Longueuil (section jeunesse)"
  ],
  "Saguenay-Lac-St-Jean": [
    "Bureau Chicoutimi",
    "Bureau Alma",
    "Bureau Roberval",
    "Bureau Dolbeau-Mistassini",
    "Bureau La Baie",
    "Bureau Jonquière"
  ]
};

// Noms des picklists originaux à masquer dans le wizard
export const LEGACY_BUREAU_FIELDS = [
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Abitibi_T_miscamingue",
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_C_te_Nord",
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Estrie",
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Laurentides_Lanaudi_re",
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Mauricie_Bois_Franc",
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Bas_Saint_Laurent_Gasp_sie",
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Montr_al_Laval",
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Outaouais",
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Qu_bec",
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Rive_Sud",
  "LISTE_DES_BUREAUX_D_AIDE_JURIDIQUE_DU_CENTRE_Saguenay"
];
